import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { User, ChevronDown,   Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const [userData,setUserData] = useState({})

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.profile-dropdown')) {
        setIsProfileDropdownOpen(false);
      }
      if (!event.target.closest('.mobile-menu-button') && !event.target.closest('.mobile-menu')) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    const userStr = localStorage.getItem('user')
    const user = JSON.parse(userStr)
    console.log("UserData:",user)
     setUserData(user)
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  // const handleSignOut = () => {
  //   // Add your sign out logic here
  //   console.log('Signing out...');
  //   navigate('/');
  //   localStorage.clear()
  // };

  // Navigation items with their routes
  const navigationItems = [
    {
      name: 'Payment Vouchers',
      path: '/home',
      exactMatch: true 
    },
    {
      name: 'Create Payment Vouchers',
      path: '/home/payment-voucher',
      exactMatch: true
    },
    {
      name: 'Users',
      path: '/home/users',
      exactMatch: true,
      allowedRoles: ['superadmin']
    },
   

  ];

  const getVisibleNavigationItems = () => {
    return navigationItems.filter(item => {
      // If item has allowedRoles, only show if user role is in that list
      if (item.allowedRoles && userData.role) {
        return item.allowedRoles.includes(userData.role.toLowerCase());
      }
      // If no allowedRoles specified, show to everyone
      return true;
    });
  };


  // Function to check if a nav item is active
  const isActiveRoute = (item) => {
    if (item.exactMatch) {
      return location.pathname === item.path;
    } else {
      // For non-exact matches, check if current path starts with the item path
      return location.pathname === item.path || 
             (item.path === '/home' && (location.pathname === '/' || location.pathname.startsWith('/home')));
    }
  };

  // Get active navigation class
  const getNavLinkClass = (item, isMobile = false) => {
    const isActive = isActiveRoute(item);
    
    if (isMobile) {
      return isActive
        ? "block px-3 py-2 text-[#1B2F69] bg-blue-50 border-l-4 border-[#1B2F69] text-base font-medium"
        : "block px-3 py-2 text-gray-500 hover:text-gray-700 hover:bg-gray-50 text-base font-medium transition-colors";
    }
    
    return isActive
      ? "text-[#1B2F69] border-b-2 border-[#1B2F69] px-1 pt-1 pb-4 text-sm font-medium"
      : "text-gray-500 hover:text-gray-700 border-transparent hover:border-gray-300 border-b-2 px-1 pt-1 pb-4 text-sm font-medium transition-colors";
  };

  const visibleNavItems = getVisibleNavigationItems();

  return (
    <nav className="bg-white shadow-lg border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Left side - Logo and Navigation */}
          <div className="flex items-center">
            {/* Logo */}
            <div className="flex-shrink-0 flex items-center">
              <div className="w-12 h-12 bg-[#1B2F69] rounded-lg flex items-center justify-center">
                <img
                  src="/netgatelogo.png"
                  alt="NetGate Lanka Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <span className="ml-2 text-xl font-bold text-gray-900 hidden sm:block">
                <span className='text-[#2EA9DB]'>Net</span>
                <span className='text-[#1B2F69]'>Gate</span> Lanka
              </span>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:ml-8 md:flex md:space-x-8">
            {visibleNavItems.map((item) => (
                <a
                  key={item.path}
                  href={item.path}
                  className={getNavLinkClass(item)}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(item.path);
                  }}
                >
                  {item.name}
                </a>
              ))}
            </div>
          </div>

          {/* Right side - Actions and Profile */}
          <div className="flex items-center space-x-4">
            {/* Profile Dropdown */}
            <div className="relative profile-dropdown">
              <button
                onClick={() => setIsProfileDropdownOpen(!isProfileDropdownOpen)}
                className="flex items-center space-x-2 p-2 text-gray-700 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#1B2F69] focus:ring-offset-2 rounded-lg transition-colors"
              >
                <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center">
                  <User className="h-4 w-4 text-gray-600" />
                </div>
                <span className="hidden md:block text-sm font-medium">{userData.name}</span>
                <ChevronDown className="h-4 w-4" />
              </button>

              {/* Profile Dropdown Menu */}
              {isProfileDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
                  <div className="px-4 py-2 border-b border-gray-100">
                    <p className="text-sm font-medium text-gray-900">{userData.name}</p>
                    <p className="text-xs text-gray-500">{userData.username}</p>
                  </div>
                  {/* <a 
                    href="#" 
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                    onClick={(e) => e.preventDefault()}
                  >
                    <User className="h-4 w-4 mr-2" />
                    Profile
                  </a>
                  <a 
                    href="#" 
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                    onClick={(e) => e.preventDefault()}
                  >
                    <Settings className="h-4 w-4 mr-2" />
                    Settings
                  </a> */}
                  {/* <div className="border-t border-gray-100">
                    <button 
                      onClick={handleSignOut}  
                      className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                    >
                      <LogOut className="h-4 w-4 mr-2" />
                      Sign out
                    </button>
                  </div> */}
                </div>
              )}
            </div>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-[#1B2F69] focus:ring-offset-2 rounded-lg transition-colors mobile-menu-button"
            >
              {isMobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-gray-200 pb-3 pt-2 mobile-menu">
            <div className="space-y-1">
            {visibleNavItems.map((item) => (
                <a
                  key={item.path}
                  href={item.path}
                  className={getNavLinkClass(item, true)}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(item.path);
                    setIsMobileMenuOpen(false);
                  }}
                >
                  {item.name}
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;